export default {
  category_name: 'Kup kartę podarunkową',
};
